module.exports = __webpack_public_path__ + "static/media/SPOT DECATHLON.9d934c87.mp4";